module.exports = __webpack_public_path__ + "static/pic05-d1e664002c7b8fbe484c4b0686b83635.jpg";